import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DatePickerComponent } from '../controls/date-picker.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-date-picker-field',
  imports: [CommonModule, FieldContainerComponent, DatePickerComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelClasses]="labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-date-picker
          [control]="control"
          [screenReaderLabel]="controlLabel || label"
          [showTime]="showTime"
          [disabled]="disabled"
        ></app-date-picker>
      </ng-template>
    </app-field-container>
  `,
  styles: ``,
})
export class DatePickerFieldComponent extends BaseFieldComponent {
  @Input()
  showTime: boolean;

  @Input()
  disabled = false;

  constructor() {
    super();
    this.valueClasses = 'tw-max-w-[280px]';
  }
}
